import type { ReservationDraft, MyReservation } from "./types";

/**
 * SPA 全体のグローバル状態。
 *
 * Phase 1.5.4 拡張：reschedule モード追加。
 * `reschedule` が non-null のとき、wizard は「日時変更モード」として動作し、
 * step3 / step4（顧客名・業種・相談内容）は元の予約から引き継いで step2 → step5 に直行する。
 */
export const state: {
  draft: ReservationDraft;
  step: number;
  /** Phase 1.5.4 拡張：日時変更対象の旧予約。null なら通常の新規予約モード */
  reschedule: MyReservation | null;
} = {
  draft: {
    reservation_date: null,
    reservation_time: null,
    customer_name: "",
    contact_method: null,
    business_type: null,
    consultation_topic: "",
  },
  step: 1,
  reschedule: null,
};

export function resetDraft() {
  state.draft = {
    reservation_date: null,
    reservation_time: null,
    customer_name: "",
    contact_method: null,
    business_type: null,
    consultation_topic: "",
  };
  state.step = 1;
  state.reschedule = null;
}

/**
 * Phase 1.5.4 拡張：日時変更モードを開始する。
 * 旧予約から customer_name / contact_method / business_type / consultation_topic を draft に引き継ぐ。
 */
export function startReschedule(oldReservation: MyReservation): void {
  state.reschedule = oldReservation;
  state.draft = {
    reservation_date: null,
    reservation_time: null,
    customer_name: oldReservation.customer_name,
    contact_method: oldReservation.contact_method,
    business_type: oldReservation.business_type,
    consultation_topic: "", // 旧の相談内容は LIFF API から返ってこないので空（D1 側で旧予約から自動引き継ぎ）
  };
  state.step = 1;
}
